<template>
    <div class="wrap">
        <div class="upType">
            <div :class="isOriginal?'tab active':'tab'" @click="tabOriginal(1)">
                存证
            </div>
            <div class="fgx"></div>
            <div :class="isOriginal?'tab':'tab active'" @click="tabOriginal(2)">
                脱敏认证
            </div>
        </div>
        <div class="addfileWrap">
            <div class="applyName">
                <dl>
                    <dt>申请人：</dt>
                    <!--已认证的主账号-->
                    <dd v-if="attestationInfo.identificationStatus == 1 && $store.state.userInfo.userInfo.userType=='ADMIN_ACCOUNT'">
                        <span>{{information.applyName}}</span>
                        <!-- 子账号不显示该图标 -->
                        <img src="@/assets/img/certified.png" alt="" v-if="$store.state.userInfo.userInfo.userType=='ADMIN_ACCOUNT'">
                    </dd>
                    <!-- 子账号不允许编辑此项，主账号未认证的子账号 -->
                    <dd v-if="$store.state.userInfo.userInfo.userType=='AUTHORIZATION_ACCOUNT'">
                        <span>{{information.applyName}}</span>
                    </dd>
                    <!-- 主账号未认证允许填写或修改-->
                    <dd v-if="attestationInfo.identificationStatus == 2 && $store.state.userInfo.userInfo.userType=='ADMIN_ACCOUNT'">
                        <input type="text" v-model="information.applyName" placeholder="请输入申请人姓名">
                    </dd>
                </dl>
                <div class="addileArea">
                    <input
                        type="file"
                        class="uploadfile"
                        multiple="multiple"
                        ref="inputer"
                        @change="addfile(1)"
                    />
                    <div class="addBtn">
                        <img src="@/assets/img/addfile.png" alt="">
                        <p>选择需要保护的文件</p>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="pageMain" v-if="timeData.length > 0">
            <div class="fileList">
                <div class="isEdit">
                    <dl>
                        <dt>填写申请信息</dt>
                        <dd>
                            <label>统一填写</label>
                            <van-switch v-model="unity" @change="editAll" size="20px" />
                        </dd>
                    </dl>
                </div>
                <ul>
                    <li v-for="(item, index) in timeData" :key="index">
                        <div class="form">
                            <van-form validate-first @submit="submit" @failed="failed" ref="formData">
                                <div class="fileName">
                                    <van-field
                                        class="inputBody"
                                        v-model="item.opusName"
                                        name="opusName"
                                        placeholder="请输入文件名称"
                                        :disabled="item.solidifySuccess == 1"
                                        :rules="[{ pattern, message: '请输入文件名称' },{validator:fileNameValidate,message: '请输入100个字符以内的文件名称'}]"
                                    >
                                        <template #right-icon>
                                            <van-icon name="delete-o" class="remove" @click="remove(index)" v-if="item.solidifySuccess !== 1"/>
                                        </template>
                                    </van-field>
                                </div>
                                <div class="fileType">
                                    <div class="chooseBody">
                                        <span v-for="itemtype in fileType" :key="itemtype.title" :class="itemtype.value == item.fileType? 'myradio checkradio' : 'myradio'"  @click="chooseType(itemtype.value, index, item)">{{itemtype.title}}</span>
                                    </div>
                                </div>
                                <div class="txtDes">
                                    <div class="lable">
                                        <dl>
                                            <dt>文件内容自述:<span>(必填)</span></dt>
                                            <dd @click="template = true">申请人自述模板</dd>
                                        </dl>
                                    </div>
                                    <div>
                                        <van-field
                                            class="txtBody"
                                            name="opusDescribe"
                                            v-model="item.opusDescribe"
                                            :disabled="item.disabled || item.solidifySuccess == 1"
                                            rows="4"
                                            autosize
                                            type="textarea"
                                            placeholder="声明：申请人对文件内容自述并对真实性承担全部责任，在《可信时间戳认证证书》上展示不代表北京联合信任技术服务有限公司认可其真实性"
                                            @input="deschange($event, index)"
                                            :rules="[{ pattern, message: '请输入文件内容自述' },{validator:opusDescribeValidate,message:'输入内容不能超过300字符'}]"
                                        />
                                    </div>
                                </div>
                            </van-form>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="addileArea2">
                <input
                    type="file"
                    class="uploadfile"
                    multiple="multiple"
                    ref="inputer2"
                    @change="addfile(2)"
                />
                <div class="addBtn">
                    <img src="@/assets/img/add2.png" alt="">
                    <p>继续添加文件</p>
                </div>
            </div>
            <div class="submitBtn">
                <van-button type="info" class="submit" @click="send">申请可信时间戳</van-button>
            </div>
        </div>
        <div class="pageMain" v-else>
            <div class="explain">
                <h3>说明：</h3>
                <ul>
                    <li>
                        <strong>1.</strong>不限制文件格式和大小，即时颁发可信时间戳<sup>®️</sup>证书，立刻拥有具有法律效力的权属证明和数字产权凭证。
                    </li>
                    <li>
                        <strong>2.</strong><b>存证</b>：上传文件原件，平台存储认证，防止丢失、损毁。
                        <p><b>脱敏认证</b>：文件不上传认证，保护您的隐私和秘密。</p>
                    </li>
                    <li>
                        <strong>3.</strong>可信时间戳认证后文件不能有任何形式的修改和变化，否则无法通过可信时间戳<sup>®️</sup>验证。
                    </li>
                </ul>
            </div>
        </div>
        <van-dialog
        title="申请人自述模板"
        v-model="template"
        class="tem-dialog"
        confirmButtonColor="#008AFF"
        confirmButtonText="关闭"
        @confirm="template==false"
        >
            <ul>
                <li class="tem-li">
                    <h3>我是拥有该文件的自然人/组织：</h3>
                    <div class="tem-cnt">
                        <p>
                        本作品/文件由联合信任可信时间戳认证,版权（或其他权利）属于（权利人名称）所有，身份证号码（），未经授权,任何单位及个人禁止以任何方式使用本作品。
                        <span
                            @click="copy"
                            class="copybtn"
                            data-clipboard-text="本作品/文件由联合信任可信时间戳认证,版权（或其他权利）属于（权利人名称）所有，身份证号码（），未经授权,任何单位及个人禁止以任何方式使用本作品。"><van-icon class-prefix="vant-ali-fuzhi" class="copyicon"/>
                        </span>
                        </p>
                    </div>
                </li>
                <li class="tem-li">
                    <h3>我和其他人共同拥有该文件：</h3>
                    <div class="tem-cnt">
                        <p>
                            本作品/文件由联合信任可信时间戳认证，版权（或其他权利）属于（权利人名称及XXX）共同所有，未经授权，任何单位及个人禁止以任何方式使用本作品。
                            <span
                                @click="copy"
                                class="copybtn"
                                data-clipboard-text="本作品/文件由联合信任可信时间戳认证，版权（或其他权利）属于（权利人名称及XXX）共同所有，未经授权，任何单位及个人禁止以任何方式使用本作品。"
                                ><van-icon class-prefix="vant-ali-fuzhi" class="copyicon"/>
                            </span>
                        </p>
                    </div>
                </li>
                <li class="tem-li">
                    <h3>替其他人申请，该文件归我的客户所有，但我是他的代理人：</h3>
                    <div class="tem-cnt">
                        <p>
                            本作品/文件由联合信任可信时间戳认证，申请人作为代理人代为申请，权利属于（权利人信息）
                            所有。
                            <span
                                @click="copy"
                                class="copybtn"
                                data-clipboard-text="本作品/文件由联合信任可信时间戳认证，申请人作为代理人代为申请，权利属于（权利人信息）所有。"
                                ><van-icon class-prefix="vant-ali-fuzhi" class="copyicon"/>
                            </span>
                        </p>
                    </div>
                </li>
                <li class="ts tem-ts">
                    声明：申请人对文件内容自述并对真实性承担全部责任，在《可信时间戳认证证书》上展示不代表北京联合信任技术服务有限公司认可其真实性，
                    不担保任何证明目的。
                </li>
            </ul>
        </van-dialog>
        
        <!-- 固化弹窗 -->
        <TsaProgressPopUp
            title="正在申请可信时间戳认证"
            ref="solidifyProgressPopUp"
            v-model="opusFilePopup"
            :fileStatus="{
                waiting: '待认证',
                processing: '正在认证',
                success: '认证成功',
                fail: '固化失败',
                showResult: '已认证成功',
                fileDamage: '认证失败'
            }"
            percentage="solidifyPercentage"
            success="solidifySuccess"
            width="95%"
            :listData="timeData"
            :uploadSuccessNumber="opusFileUploadSuccessNumber"
            :AllUploadNumber="opusFileAllUploadNumber"
            @on-stop="opusFilePopupStop"
        />
        <van-dialog v-model="opusFileProgressPopupCancelShow" title="提示" class="mydialogBox" show-cancel-button confirmButtonColor="#008AFF" confirmButtonText="确认" cancelButtonText="取消" @confirm="opusFileProgressPopupConfirm" @cancel="opusFileProgressPopupCancel">
            <div class="dialog_cnt">
                <div class="content">
                    <p>关闭后“未认证成功”的文件将不再继续认证，是否确认返回修改</p>
                </div>
            </div>
        </van-dialog>

        <TsaProgressPopUp
            title="正在存证"
            ref="ossSliceUploadProgressPopUp"
            v-model="ossUploadPopup"
            :isUpFile="true"
            :fileStatus="{
                waiting: '待上传',
                processing: '正在上传',
                success: '存证成功',
                fail: '存证失败',
                showResult: '已上传成功'
            }"
            percentage="ossSliceUploadPercentage"
            success="ossSliceUploadSuccess"
            width="95%"
            :listData="timeData"
            :uploadSuccessNumber="ossSliceUploadSuccessNumber"
            :AllUploadNumber="ossSliceAllUploadNumber"
            @on-stop="ossUploadPopupStop"
        />
        <van-dialog v-model="ossUploadProgressPopupCancelShow" title="提示" class="mydialogBox" show-cancel-button confirmButtonColor="#008AFF" confirmButtonText="确认" cancelButtonText="取消" @confirm="ossUploadProgressPopupConfirm" @cancel="ossUploadProgressPopupCancel">
            <div class="dialog_cnt">
                <div class="content">
                    <p>关闭后“未上传成功”的文件将不再继续上传，是否确认返回修改</p>
                </div>
            </div>
        </van-dialog>
        <!-- 结束认证确认框 -->
        <van-dialog v-model="confirmBox" title="提示" class="mydialogBox" confirmButtonColor="#008AFF" confirmButtonText="确认" show-cancel-button cancelButtonText="取消" @confirm="overAttestation">
            <template #title>
                <van-icon name="warning"/>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <p>当前已完成<b style="color:red;margin:0 10px">{{this.overNum}}</b>个文件的认证，结束认证后剩余的文件将无法认证，未认证已扣除的时间戳将在24小时内返回到您的账户中，是否确定结束认证</p>
                </div>
            </div>
        </van-dialog>
        <!-- 上传源文件充值带关闭提示框 -->
        <van-dialog 
            v-model="buyDialog" 
            class="buyDialog" 
            :confirmButtonColor="buyDialogCnt.confirmButtonColor"
            :confirmButtonText="buyDialogCnt.confirmButtonText"
            show-cancel-button
            :cancelButtonText="buyDialogCnt.cancelButtonText"
            :before-close="openbuy"
        >
            <template #title>
                <div class="headerDialog">
                    <h3>{{buyDialogCnt.title}}</h3>
                    <van-icon name="cross" class="close" @click="close" />
                </div>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <p>{{buyDialogCnt.message}}</p>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { hashFile, hashMd5File } from '@/utils/fileHash'
import {filterParams , generateUUID} from '@/utils/filter'
import { encrypt } from '@/utils/aes.js'
import { mapState } from 'vuex'
import {opusUserInfo,opusUpdateUserInfo,opusApply,findBalance,me,user,generateStsUploadSignMessage,completeStatus,lengthCount,cancelStsUpload} from '@/api/service'
import { ExcludeRequest400 } from '@/api/index.js'
import { ossMultipartUpload,ossAbortMultipartUpload} from '@/utils/ossMultipartUpload'
import TsaProgressPopUp from '@/components/ApplyTime/TsaProgressPopUp'
var interval = null;
export default {
    data() {
        return {
            pattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            isOriginal:true,
            fileType: [
                {
                    title: '商业秘密',
                    value: 109,
                },
                {
                    title: '工业项目',
                    value: 119,
                },
                {
                    title: '软件项目',
                    value: 108,
                },
                {
                    title: '硬件项目',
                    value: 120,
                },
                {
                    title: '科研成果',
                    value: 121,
                },
                {
                    title: '数据资产',
                    value: 122,
                },
                {
                    title: '商标设计',
                    value: 123,
                },
                {
                    title: '专利文档',
                    value: 124,
                },
                {
                    title: '文字作品',
                    value: 101,
                },
                {
                    title: '视听作品',
                    value: 112,
                },
                {
                    title: '摄影作品',
                    value: 110,
                },
                {
                    title: '美术作品',
                    value: 104,
                },
                {
                    title: '音乐作品',
                    value: 102,
                },
                {
                    title: '设计作品',
                    value: 105,
                },
                {
                    title: '讲义课件',
                    value: 125,
                },
                {
                    title: '其它',
                    value: 999,
                },
            ],
            timeData:[],
            //选择文件相关
            uploadType: false,
            attestationInfo:{},
            information: {
                applyName: '',
                applyIdType: '',
                applyIdNumber: '',
            },
            showNameType:'',
            fil: {},
            files: [],
            zhe: false,
            currentRate:0,
            percentage: 0,
            totalSize: 0,
            totalPos: 0,
            unity: false, //统一编辑
            checked: false, //上传源文件
            template: false, //自述模板
            confirmBox:false,//结束认证确认框
            active: 0, //当前状态
            isAddfile: true,
            overNum:0,//已认证完成的文件数
            result: [],//不上传文件进度数据
            serialNos: [],
            buyDialog:false,
            buyDialogCnt:{
                message:'sadasdasddas',
                title:'提示',
                confirmButtonColor:"#008AFF",
                confirmButtonText:"去充值", 
                cancelButtonText:"我已充值",
            },

            currentIndex:0,//当前计算hash的索引
            opusFilePopup: false, // 固化文件进度弹窗
            ossUploadPopup: false, // 存证 上传到oss的进度弹窗
            opusFileProgressPopupCancelShow: false,
            ossUploadProgressPopupCancelShow: false,
            ossUploadProgressPopupCancelDisabled: false,
            allowSolidification:true,//是否允许固化
            allowExistingEvidence: true,//是否允许存证
            tsCount:1,
            TotalTimestampsCount:0
        };
    },

    components: {TsaProgressPopUp},

    watch:{
        stepsActive (newVal, oldVal) {
            this.btnFix=false;
        },
        opusFilePopup (val) { // 有改动
            if (!val) {
                this.opusFileProgressPopupCancelShow = false
            }
        },
        ossUploadPopup (val) { // 有改动
            if (!val) {
                this.ossUploadProgressPopupCancelShow = false
            }
        }
    },

    computed: {
        ...mapState({}),
        userInfo: {
            get() {
                return this.$store.state.userInfo.userInfo
            },
            set(val) {
                this.$store.state.userInfo.userInfo = val
            },
        },
        access_token(){
            return this.$store.state.userInfo.me.accessToken
        },
        // 固化时候的成功的数量
        opusFileUploadSuccessNumber () {
            let array = this.timeData.filter(item => {
                return item.solidifySuccess === 1
            })
            return array.length
        },
        // 固化时候的总数量 (既全量)
        opusFileAllUploadNumber () {
            return this.timeData.length
        },
        // 分片上传成功的数量
        ossSliceUploadSuccessNumber () {
            let array = this.timeData.filter(item => {
                return item.ossSliceUploadSuccess === 1 && this.isOriginal===true
            })
            return array.length 
        },
        // 分片上传时候的总数量
        ossSliceAllUploadNumber () {
            if(this.isOriginal){
                return this.timeData.length
            }else{
                return 0
            }
        },
    },

    created() {
        this.getUserInfo();
    },

    mounted() {
        // setTimeout(() => {
        //     this.opusFilePopup=true
        // }, 1000);
    },

    destroyed(){
        clearInterval(interval);
    },

    methods: {
        delay (time) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve()
                }, time)
            })
        },
        // 获取用户信息
        async getUserInfo() {
            let res = await opusUserInfo()
            this.attestationInfo = res;
            this.showNameType=res.showNameType;
            this.information = {
                applyName: res.applyName,
                applyIdType: res.applyIdType,
                applyIdNumber: res.applyIdNumber,
            }
        },
        opusDescribeValidate(val){
            return val.length<=300
        },
        fileNameValidate(val){
            return val.length<=100
        },
        onFailed(errorInfo) {
            console.log('failed', errorInfo);
        },
        tabOriginal(n){
            if(this.opusFileUploadSuccessNumber==0){
                n==1 ? this.isOriginal=true : this.isOriginal=false
            }else{
                this.$toast(`检测到当前已有固化成功的文件，不可再修改认证方式。`)
            }
        },
        addfile(n){
            let inputDOM;
            if (n == 1) {
                inputDOM = this.$refs.inputer
            }
            if(n == 2){
                inputDOM = this.$refs.inputer2
                if ((inputDOM.files.length+this.timeData.length) > 20) {
                    this.$toast('上传的文件个数不可以超过20个')
                    this.$refs.inputer2.value = null;
                    return false
                }
            }
            this.fil = inputDOM.files
            if (this.fil.length == 0) {
                return false
            }
            let obj
            for (let i = 0; i < this.fil.length; i++) {
                if(Math.floor(this.fil[i].size==0)){
                    this.$toast(`文件${this.fil[i].name}大小为0kb，无法确权，已为您从列表移除。`)
                    return false
                }
                if (this.unity) {
                    obj = {
                        fileItem: this.fil[i],
                        opusName: this.fil[i].name,
                        opusDescribe: this.timeData[0].opusDescribe,
                        fileType: this.timeData[0].fileType,
                        disabled: true,
                        modified: true,
                        percentage: 0,
                        opusApplyType:2,

                        //新版增加
                        id:'',
                        uuid: generateUUID(),
                        serialNo:'',
                        solidifyPercentage: 0, // 固化上传百分比百分比
                        solidifySuccess: 0, // 是否固化完成 // 0 未完成， 1 成功， 2 固化失败
                        ossSliceUploadPercentage: 0, // 分片上传百分比
                        ossSliceUploadSuccess: 0, // 是否分片上传完成 // 0 未完成， 1 成功， 2 上传失败
                        applyFileSize: this.fil[i].size, // 文件的大小，用来进行存证扣费用的
                    }
                }else{
                    obj = {
                        fileItem: this.fil[i],
                        opusName: this.fil[i].name,
                        opusDescribe: '',
                        fileType: 999,
                        disabled: false,
                        modified: true,
                        percentage: 0,
                        opusApplyType:2,

                        //新版增加
                        id:'',
                        uuid: generateUUID(),
                        serialNo:'',
                        solidifyPercentage: 0, // 固化上传百分比百分比
                        solidifySuccess: 0, // 是否固化完成 // 0 未完成， 1 成功， 2 固化失败
                        ossSliceUploadPercentage: 0, // 分片上传百分比
                        ossSliceUploadSuccess: 0, // 是否分片上传完成 // 0 未完成， 1 成功， 2 上传失败
                        applyFileSize: this.fil[i].size, // 文件的大小，用来进行存证扣费用的
                    }
                }
                this.totalSize += Math.floor(this.fil[i].size)
                this.timeData.push(obj)
            }
        },
        chooseType(value, index, item, status = true) {
            if (item.solidifySuccess == 1){
                return false
            }
            if (item.disabled) {
                return false
            }
            if (this.unity && status) {
                this.timeData.forEach((v, i) => {
                    if(v.solidifySuccess !== 1){
                        v.fileType = value
                        this.$set(this.timeData, i, v)
                    }
                })
                return false
            }
            this.timeData[index].fileType = value
            let obj = this.timeData[index]
            this.$set(this.timeData, index, obj)
        },
        remove(index) {
            this.timeData.splice(index, 1)
            if(this.timeData.length>0){
                this.$refs.inputer.value = null;
                this.$refs.inputer2.value = null;
                this.timeData[0].disabled = false
            }else{
                this.unity=false;
                this.$refs.inputer.value = null;
            }
        },
        editAll() {
            if (this.unity) {
                let obj = {
                    opusDescribe: this.timeData[0].opusDescribe,
                    fileType: this.timeData[0].fileType,
                    disabled: true,
                }
                this.timeData.forEach((v, i) => {
                    if(v.solidifySuccess !== 1){
                        v = { ...v, ...obj }
                        if (i == 0) {
                            v.disabled = false
                        }
                        this.$set(this.timeData, i, v)
                    }
                })
            } else {
                this.timeData.forEach((v, i) => {
                    v.disabled = false
                    this.$set(this.timeData, i, v)
                })
            }
        },
        deschange(value, index, status = true) {
            if (this.unity && status) {
                this.timeData.forEach((v, i) => {
                    if(v.solidifySuccess !== 1){
                        v.opusDescribe = value
                        this.$set(this.timeData, i, v)
                    }
                })
                return false
            }
            this.timeData[index].opusDescribe = value
            let obj = this.timeData[index]
            this.$set(this.timeData, index, obj)
        },
        submit(values){
            console.log(values);
        },
        failed(errorInfo){
            console.log(errorInfo);
        },
        // 计算所需的时间戳
        calculateTheRequiredTimestamp (callback) {
            return new Promise(async(resolve, reject) => {
                try {
                    let list = []
                    let TotalTimestampsCount = 0 // 总共的时间戳数量
                    let solidifyCount = this.timeData.filter(item => {
                        // return (item.storeType === 'DESENSITIZE_STORE' && !item.id) || (item.storeType === 'SAVE_STORE' && item.solidifySuccess !== 1)
                        return item.solidifySuccess !== 1
                    }).length // 需要固化的时间戳数量

                    let existingEvidenceCount = 0 // 存证的时间戳数量
                    this.timeData.map(item => {
                        if (this.isOriginal && !item.id) {
                            list.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0
                            })
                        }
                    })
                    let { tsCount, resultList } = await lengthCount(list)
                    // 计算固化所需要的时间戳
                    solidifyCount = parseInt((tsCount * solidifyCount).toFixed(0))
                    // 计算存证所需要的时间戳
                    resultList && resultList.map(item => {
                        existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                    })
                    // 计算时间戳总数
                    TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
                    resolve(TotalTimestampsCount)
                } catch (error) {
                    reject(error)
                    callback && callback()
                    
                }
            })
        },
        //计算当前应扣减的时间戳数量，用于判断余额是否够用
        getAccountNum(){
            let TotalTimestampsCount = 0 // 总共的时间戳数量
            let solidifyCount = this.timeData.length // 固化的时间戳数量
            let existingEvidenceCount = 0 // 存证的时间戳数量
            let solidifySuccessCount=0 //已固化完成的时间戳数量
            let existingEvidenceSuccessCount=0 //已存证完成的时间戳数量
            // 计算固化所需要的时间戳
            solidifyCount = parseInt((this.tsCount * solidifyCount).toFixed(0))
            // 计算存证所需要的时间戳
            this.timeData.map(item => {
                if(item.solidifySuccess==1){
                    solidifySuccessCount=parseInt((solidifySuccessCount + 1).toFixed(0))
                }
                if(item.ossSliceUploadSuccess==1){
                    existingEvidenceSuccessCount=parseInt((existingEvidenceSuccessCount + item.storeCount).toFixed(0))
                }
                existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
            })
            // 计算时间戳总数
            TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
            //计算应该扣费的时间戳总数
            let deductTimestampsCount=TotalTimestampsCount-existingEvidenceSuccessCount-solidifySuccessCount
            return deductTimestampsCount
        },
        async send(){
            let that=this;
            this.errorInfo=false;
            if (!this.information.applyName) {
                this.$toast("请填写申请人姓名");
                return false;
            }
            if (this.information.applyName.length>50) {
                this.$toast("申请人信息需少于50个字");
                return false;
            }
            let P1=()=>{
                return new Promise( (resolve, reject)=> {
                    that.timeData.forEach(async (v, i) => {
                        await this.$refs.formData[i].submit();
                        if (!v.opusName || !v.fileType || !v.opusDescribe) {
                            that.$toast('当前页面中有必填项没有填写')
                            reject('1')
                            return false
                        }
                        if(v.opusName.length>100){
                            that.$toast('输入的文件名称不能超过100字符')
                            reject('2')
                            return false
                        }
                        if(v.opusDescribe.length>300){
                            that.$toast('文件内容自述不能超过300字符')
                            reject('3')
                            return false
                        }
                        if(i==(that.timeData.length-1)){
                            resolve();
                        }
                    })
                })
            }
            P1().then(async ()=>{
                console.log(that.errorInfo)
                //子账号需要获取最新状态，防止在当前申请期间主账号修改其权限信息等内容。
                if(that.$store.state.userInfo.userInfo.userType=='AUTHORIZATION_ACCOUNT'){
                    await user().then((res) => {
                        if (res.forbidden) { 
                            that.$dialog.confirm({
                                title:'提示', 
                                message:'您无权使用该服务，请与主账号管理员联系授权', 
                                confirmButtonColor:'#008AFF',
                                confirmButtonText: '确定',
                            }).then(()=>{
                                window.location.href = process.env.VUE_APP_ACCOUNTUI
                            })
                            return false
                        }
                        that.$store.commit('userInfo/setUserInfo', res);
                    }).then(async ()=>{
                        try {
                            await that.getUserInfo();
                        } catch (err) {
                            that.$toast(err.data.message)
                            return false
                        }
                    }).catch((err) => {
                        console.log(err)
                    });
                }
                try {
                    that.information=filterParams(that.information);
                    await opusUpdateUserInfo(that.information);
                    let paramsData=[];
                    this.timeData.forEach((v, i) => {
                        paramsData.push({
                            keyType:0,
                            fileSize:v.applyFileSize,
                            key:v.uuid,
                        })
                    })
                    let res=await lengthCount(paramsData)
                    this.tsCount=res.tsCount;
                    let resultList=res.resultList;
                    let P2=()=>{
                        return new Promise((resolve, reject)=> {
                            that.timeData.forEach((v, i) => {
                                let data = resultList.find(i => v.uuid == i.key)
                                v = { ...v, ...that.information,storeCount:this.isOriginal? data.storeCount : 0,};
                                that.$set(that.timeData, i, v);
                            });
                            resolve();
                        })
                    }
                    P2().then(async()=>{
                        try {
                            // this.opusFilePopup=true;
                            let res = await findBalance(this.getAccountNum());
                            if (res.deductible == 1) {
                                await this.fileStart({ solidifyType: 1 }) //第一个弹框脱敏认证
                                await this.existingEvidence({ existingEvidenceType: 1}) // 存证 分片上传
                                let balance = await findBalance(0)
                                that.$store.commit('balance/setBalance', balance)
                                sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                if(this.serialNos.length>0){
                                    this.$router.replace({
                                        path: '/time/ApplyResult',
                                    })
                                }else{
                                    location.reload();
                                }
                                
                            }else if (res.deductible == 4) {//身份主账号，余额不足
                                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                                that.$dialog.confirm({
                                    title: that.timeStampArrearageMessage(),
                                    message: res.errorMessage,
                                    confirmButtonColor:'#008AFF',
                                    confirmButtonText: '去充值',
                                    cancelButtonText: '我已充值',
                                    beforeClose: (action, done) => {
                                        if (action === 'confirm') {
                                            that.$router.push({
                                                path:'/mine/Account',
                                                query:{
                                                    url:process.env.VUE_APP_ACCOUNTUI+`/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')?this.$getlocalStorage('partnerType'):0}`
                                                }
                                            })
                                            done();
                                        } else {
                                            //this.send();需要自己点按钮，防止用户不想继续了。
                                            done()
                                        }
                                    },
                                }).then(() => {
                                    console.log('去充值吧')
                                }).catch(async () => {
                                    console.log('取消')
                                    let balance = await findBalance(0)
                                    that.$store.commit('balance/setBalance', balance)

                                })
                                return false
                            }else if (res.deductible == 2) {//身份子账号，主账号余额不足
                                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                                that.$dialog.alert({
                                    title:that.timeStampArrearageMessage(), 
                                    message:res.errorMessage, 
                                    confirmButtonColor:'#008AFF',
                                    confirmButtonText: '我知道了',
                                })
                                return false
                            }else{//deductible=3 身份子账号，主账号分配次数达上限
                                //that.$toast('您的时间戳已用完，请联系主账号再次分配。')
                                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                                that.$dialog.alert({
                                    title:that.timeStampArrearageMessage(), 
                                    message:'您的时间戳已用完，请联系主账号再次分配。', 
                                    confirmButtonColor:'#008AFF',
                                    confirmButtonText: '我知道了',
                                })
                                return false
                            }
                        } catch (error) {
                            if(error.name&&error.name=='cancel'){
                                console.log('取消存证')
                            }else if(error.data.code==300026){
                                this.$toast(error.data.message)
                            }else{
                                this.$toast('服务异常，请联系客服')
                            }
                        }
                    })
                } catch(error) {
                    console.log(error)
                }
            })
        },
        async overAttestation(){
            if(this.overNum==0){
                location.reload();
            }else{
                clearInterval(interval);
                let balance = await findBalance(0)
                this.$store.commit('balance/setBalance', balance)
                sessionStorage.setItem('serialNos', JSON.stringify(this.serialNos))
                this.$router.replace({
                    path: '/time/ApplyResult',
                })
            }
        },
        copy() {
            var clipboard = new this.Clipboard('.copybtn')
            var that = this
            clipboard.on('success', (e) => {
                // console.log('复制成功')
                // 释放内存
                that.$toast.success('复制成功')
                setTimeout(function() {
                    that.template = false
                }, 2000)
                clipboard.destroy()
            })
            clipboard.on('error', (e) => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')
                that.$toast('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        openbuy(action, done){ 
            if (action === 'confirm') {
                //新开窗口为了返回后可以继续接着欠费之前的一些状态接着往下固化，不需要用户在重新编辑上传。
                window.open(process.env.VUE_APP_ACCOUNTUI + `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0}`)
                done(false)
            } else if(action === 'cancel'){
                this.send();
                done();
            }else{
                if(this.opusFilePopup = true){//当前固化弹框打开，要停止固化
                    //this.opusFilePopupStop()
                    this.opusFileProgressPopupConfirm();
                }
                if(this.ossUploadPopup = true){//当前存证弹框打开，要停止存证
                    // this.ossUploadPopupStop()
                    this.ossUploadProgressPopupConfirm()
                }
                done();
            }
        },
        gobuy(path) {
            this.$router.push({
                path:'/mine/Account',
                query:{
                    url:process.env.VUE_APP_ACCOUNTUI+path
                }
            })
        },
        close(){
            this.buyDialog=false;
        },

        // 1.开启文件固化程序先脱敏扣费弹框 solidifyType 正常固化值为 1， 点击结束固化弹窗中的取消按钮，执行的接续固化 值为 2
        async fileStart({ solidifyType }) {
            return new Promise(async (resolve, reject) => {
                let obj;
                let hasUpload;//list中是否有存证的项
                try {
                    if (this.opusFileUploadSuccessNumber === this.opusFileAllUploadNumber) {
                        clearInterval(interval) // 结束保活
                        interval = null // 结束保活
                        this.opusFilePopup = false // 关闭弹窗
                        resolve()
                        return
                    }
                    // 进行保活处理
                    interval = setInterval(()=> {
                        me().then((res) => {
                            console.log('正在保活')
                        }).catch((err) => {
                            console.log(err)
                        });
                    }, 60000);
                    this.allowSolidification = true
                    if (solidifyType === 1) {
                        this.timeData.map(item => {
                            if (item.solidifySuccess !== 1) {
                                item.solidifyPercentage = 0
                                item.solidifySuccess = 0
                            }
                        })
                    }
                    this.opusFilePopup = true
                    await this.delay(0) // 用来代替 nextTick
                    this.$refs.solidifyProgressPopUp.initScroll()
                    for (let i = 0; i < this.timeData.length; i++) {
                        obj = this.timeData[i]
                        //为首都知产而加字段partnerType=1代表首都知产用户
                        obj.partnerType = this.$getlocalStorage('partnerType') || 0;
                        this.$refs.solidifyProgressPopUp.autoScroll(obj.uuid)
                        if ((solidifyType === 1 && obj.solidifySuccess !== 1) || (solidifyType === 2 && obj.solidifySuccess === 0)) { // 如果是再次固化的需要去除 固化失败的
                            this.currentIndex = i // 设置当前索引
                            let reader;
                            let fileHash = await hashFile(obj.fileItem, 'SHA256', (percentage) => {
                                if (this.allowSolidification === false) { // 固化结束
                                    reader && reader.abort()
                                    reader = null
                                    return
                                }
                                obj.solidifyPercentage = percentage
                            }, ({ reader }) => {
                                reader = reader
                                if (this.allowSolidification === false) { // 固化结束
                                    reader && reader.abort()
                                    reader = null
                                    return
                                }
                            }, 1)
                            if(fileHash===null){
                                obj.solidifySuccess = 3;
                            }else{
                                obj.fileHash = fileHash;
                                // console.log('第一步的hash', sha256)
                                if (this.allowSolidification === false) return
                                let res=await opusApply(obj)
                                let {code, id, message, serialNo} = res;
                                if (code === 9523100) { //固化成功
                                    // obj.md5 = CryptoJs.enc.Base64.stringify(md5)
                                    obj.serialNo = serialNo
                                    this.serialNos.push(serialNo);
                                    if (!this.isOriginal) { // 如果是脱敏的 认为是固化成功
                                        obj.id = id
                                    }
                                    obj.solidifySuccess = 1
                                    this.timeData[i]=obj
                                    this.$set(this.timeData, i, obj)
                                    let balance = await findBalance(0)
                                    this.$store.commit('balance/setBalance', balance)
                                } else {
                                    if (this.solidifyFail(code, obj, message)) {
                                        return
                                    }
                                }
                            }
                            //如果没有存证的，那么只有固化一个弹框，判断当前是最后一个并且已完成固化，直接跳成功页。
                            if(this.opusFileProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.solidifySuccess == 1 && !hasUpload){
                                sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                this.$router.replace({
                                    path: '/time/ApplyResult',
                                })
                                return
                            }
                            // 如果弹出了取消固化的弹窗，就自动停止，不进入下一个循环
                            if (this.opusFileProgressPopupCancelShow === true) return
                        }
                    }
                    await this.delay(1000) // 如果此时结束了固化
                    console.log('固化结束')
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    for (let i = 0; i < this.timeData.length; i++) {
                        if (this.timeData[i].solidifySuccess === 3) {
                            this.timeData.splice(i, 1)
                            i--
                        }
                    }
                    if (this.opusFileUploadSuccessNumber === this.opusFileAllUploadNumber) {
                        this.opusFilePopup = false // 关闭弹窗
                        console.log('****************')
                        // if (this.allowSolidification === true) { // 允许固化的时候固化
                        //     callback && callback()
                        // }
                        resolve()
                    } else {
                        console.log('------solidify-----has---fail---')
                        reject()
                    }
                } catch (error) {
                    console.log(error)
                    console.log('------solidify-----error---')
                    obj.solidifySuccess = 2 
                    reject(error)
                }
            })
        },
        async solidifyFail (code, obj, message) {
            obj.solidifySuccess = 2;
            if (code === 9523101) { // 固化失败了
                //obj.solidifySuccess = 2
                return false
            } else if (code === 10001) { //
                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                if(this.userInfo.userType === 'ADMIN_ACCOUNT') { // 主账号
                    this.buyDialog=true;
                    this.buyDialogCnt.title=this.timeStampArrearageMessage();
                    this.buyDialogCnt.message=message;
                    this.opusFilePopup = false
                    this.opusFileProgressPopupCancelShow = false
                    return true
                } else {
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(), 
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    this.opusFilePopup = false
                    this.opusFileProgressPopupCancelShow = false
                    return true
                }
            } else {
                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                // 10013 子账号超出最大限额
                this.$dialog.alert({
                    title:this.timeStampArrearageMessage(),
                    message:message, 
                    confirmButtonColor:'#008AFF',
                    confirmButtonText: '我知道了',
                })
                this.opusFilePopup = false
                this.opusFileProgressPopupCancelShow = false
                return true
            }
        },
        //固化过程中，点击取消显示的弹窗
        opusFilePopupStop () {
            this.opusFileProgressPopupCancelShow = true
        },
        //固化过程中，点击取消
        async opusFileProgressPopupCancel () {
            let currentObj = this.timeData[this.currentIndex]
            // 如果结束固化的过程中存在 hash算完并且 opusApply 还没处理完的情况下
            if (currentObj.solidifyPercentage === 100 && currentObj.solidifySuccess === 0) {
                this.$toast('当前文件即将认证成功，请稍后处理');
            } else {
                this.opusFileProgressPopupCancelShow = false // 关闭弹窗 （必须先关闭）
                // 如果点击取消的时候，流程没有进入固化 代码继续往下走，如果已经进入了固化接口，那么执行下面的函数，重新执行固化函数，继续固化
                if (currentObj.solidifySuccess !== 0) {
                    await this.fileStart({ solidifyType: 2 })
                    await this.existingEvidence({ existingEvidenceType: 2 })
                }
            }
        },
        //固化过程中，点击确定结束固化
        opusFileProgressPopupConfirm () {
            let currentObj = this.timeData[this.currentIndex]
            // 如果结束固化的过程中存在 hash算完并且 opusApply 还没处理完的情况下
            if (currentObj.solidifyPercentage === 100 && currentObj.solidifySuccess === 0) {
                this.$toast('当前文件即将认证成功，请稍后处理');
            } else {
                clearInterval(interval) // 结束保活
                interval = null // 结束保活
                this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                this.allowSolidification = false
                this.opusFilePopup = false
                this.opusFileProgressPopupCancelShow = false
            }
        },
        // 2.全部脱敏扣费后再继续存证上传扣费
        async existingEvidence ({ existingEvidenceType }) {
            return new Promise(async (resolve, reject) => {
                console.log(this.ossSliceUploadSuccessNumber+'----'+this.ossSliceAllUploadNumber)
                if (this.ossSliceUploadSuccessNumber === this.ossSliceAllUploadNumber) {
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    this.ossUploadPopup = false // 有改动
                    resolve()
                    return
                }
                let obj;
                // 需要判断钱是否够
                try {
                    // 进行保活处理
                    interval = setInterval(()=> {
                        me().then((res) => {
                            console.log('正在保活')
                        }).catch((err) => {
                            console.log(err)
                        });
                    }, 60000);
                    this.allowExistingEvidence = true
                    if (existingEvidenceType === 1) {
                        this.timeData.map(item => {
                            if (item.ossSliceUploadSuccess !== 1 && this.isOriginal) {
                                item.ossSliceUploadPercentage = 0
                                item.ossSliceUploadSuccess = 0
                            }
                        })
                    }
                    this.ossUploadPopup = true
                    await this.delay(0) // 用来代替 nextTick
                    this.$refs.ossSliceUploadProgressPopUp.initScroll()
                    for (let i = 0; i < this.timeData.length; i++) {
                        obj = this.timeData[i]
                        if (this.isOriginal && ((existingEvidenceType === 1 && !obj.id) || (existingEvidenceType === 2 && obj.ossSliceUploadSuccess === 0) )) {
                            this.currentIndex = i
                            this.$refs.ossSliceUploadProgressPopUp.autoScroll(obj.uuid)
                            let { fileHash, serialNo, fileItem, applyFileSize } = obj
                            if (this.allowExistingEvidence === false) return
                            let { accessKey, secretKey, secretToken, bucket, key , storeId} = await generateStsUploadSignMessage(encrypt({
                                serialNo, 
                                applyFileSize,
                                partnerType:this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0
                            }), 'nqio8Mem5oDNNBxOStIAlIsxrtWAx/c8')
                            obj.storeId = storeId
                            if (this.allowExistingEvidence === false) return
                            await ossMultipartUpload({
                                fileHash,
                                accessKey,
                                secretKey,
                                secretToken,
                                bucket,
                                key,
                                file:fileItem,
                            }, ({ percentage }) => {
                                obj.ossSliceUploadPercentage = percentage
                            })
                            if (this.allowExistingEvidence === false) return
                            let { id } = await this.ossSliceUploadGetStatus({serialNo,storeId})
                            if (id) { 
                                obj.ossSliceUploadSuccess = 1 // 上传成功
                                obj.id = id
                            } else {
                                obj.ossSliceUploadSuccess = 2 // 上传失败
                            }
                            this.timeData[i]=obj;
                            this.$set(this.timeData, i, obj)
                            if(this.ossUploadProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.ossSliceUploadSuccess == 1){//再点取消的时候，最后一个已经存证完成，那就直接跳转到成功页
                                sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                this.$router.replace({
                                    path: '/time/ApplyResult',
                                })
                                return
                            }
                            if (this.ossUploadProgressPopupCancelShow === true) return
                        }
                    }
                    await this.delay(1000) // 1秒后结束固化
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    if (this.ossSliceUploadSuccessNumber === this.ossSliceAllUploadNumber) {
                        this.ossUploadPopup = false
                        resolve()
                    } else {
                        reject()
                    }
                } catch (error) {
                    if (error && error.config) {
                        let { code, message } = error.data
                        if (ExcludeRequest400.indexOf(error.config.url) > -1) {
                            // 存证失败的情况
                            this.existingEvidenceFail(code, obj, message)
                            return
                        }
                    }
                    reject(error)
                }
            })
        },
        // 查询最新的存证状态
        ossSliceUploadGetStatus ({serialNo,storeId}, onOff) {
            console.log(serialNo);
            return new Promise((resolve, reject) => {
                let time = null;
                clearTimeout(time)
                const getStatus = ({ serialNo, storeId }) => {
                    if (this.allowExistingEvidence === false && !onOff) {
                        resolve({})
                        return
                    }
                    completeStatus({serialNo,storeId}).then(async res => {
                        if (this.allowExistingEvidence === true || onOff) {
                            if (res.sourceFileUploadType === 0) { // 状态没有更新，继续轮询
                                time = setTimeout(() => {
                                    getStatus({ serialNo, storeId })
                                }, 1000)
                            } else {
                                resolve(res)
                                clearTimeout(time)
                                time = null
                                let balance = await findBalance(0)
                                this.$store.commit('balance/setBalance', balance)
                            }
                        } else {
                            resolve({})
                            clearTimeout(time)
                            time = null
                        }
                    }).catch((error) => {
                        resolve({})
                        clearTimeout(time)
                        time = null
                    })
                }
                getStatus({ serialNo, storeId })
            })
        },
        timeStampArrearageMessage () {
            return '本次申请需要消耗时间戳 ' + this.TotalTimestampsCount + ' 个'
        },
        // 存证失败
        async existingEvidenceFail (code,obj, message) {
            // code 2 您的主账号余额不足，请联系主账号充值
            // code 3 您的使用个数已达上限，请联系主账号分配
            // code 4 您的余额不足，请充值后在使用
            message = message || '系统错误'
            this.ossUploadPopup = false // 关闭存证进度弹窗
            this.ossUploadProgressPopupCancelShow = false // 关闭结束存证的弹窗（会出现，几率很小）
            obj.ossSliceUploadSuccess = 2
            clearInterval(interval) // 清空保活接口
            interval = null
            this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
            switch (code) {
                case 2:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    break
                case 3:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    break
                case 4:
                    this.buyDialog=true;
                    this.buyDialogCnt.title=this.timeStampArrearageMessage()
                    this.buyDialogCnt.message=message;
                    break
                default:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
            }
        },
        //存证过程中，点击取消显示的弹窗
        ossUploadPopupStop () {
            this.ossUploadProgressPopupCancelShow = true
        },
        //存证过程中，点击结束存证
        async ossUploadProgressPopupConfirm () {
            try {
                this.ossUploadProgressPopupCancelDisabled = true // 禁止重复点击
                let currentObj = this.timeData[this.currentIndex]
                if (this.isOriginal && currentObj.ossSliceUploadPercentage === 100 && currentObj.ossSliceUploadSuccess === 0) {
                    this.$toast('当前文件即将上传成功，请稍后处理');
                } else {
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    // 这里可能还需要清除一个定时器
                    this.allowExistingEvidence = false // 存证不允许
                    // 如果上传成功的都不允许删除
                    if (currentObj.ossSliceUploadPercentage < 100) {
                            await ossAbortMultipartUpload() // 取消oss请求
                            // 需要调用终止分片的接口 （已经上传到服务器的就不能被取消了）
                            await cancelStsUpload({
                                serialNo: currentObj.serialNo,
                                storeId: currentObj.storeId,
                            })
                        }
                    this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    this.ossUploadPopup = false
                    this.ossUploadProgressPopupCancelShow = false
                }
                this.ossUploadProgressPopupCancelDisabled = false // 禁止重复点击
            } catch (error) {
                if (error && error.status === 400 && error.data && error.data.code == -1 && error.config && error.config.url === '/opus/cancelStsUpload') {
                    this.allowExistingEvidence = true
                    let { id } = await this.ossSliceUploadGetStatus({serialNo,storeId}, true)
                    if (id) {
                        currentObj.ossSliceUploadSuccess = 1 // 上传成功
                        currentObj.id = id
                        currentObj.ossSliceUploadPercentage = 100 // 成功
                    } 
                    await this.existingEvidence({ existingEvidenceType: 2 })
                } else {
                    await ossAbortMultipartUpload() // 取消oss请求
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    this.allowExistingEvidence = false // 存证不允许
                    this.ossUploadProgressPopupCancelDisabled = false // 禁止重复点击
                    this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    this.ossUploadPopup = false
                    this.ossUploadProgressPopupCancelShow = false
                }
            }
        },
        async ossUploadProgressPopupCancel () {
            let currentObj = this.timeData[this.currentIndex]
            if (this.isOriginal && currentObj.ossSliceUploadPercentage === 100 && currentObj.ossSliceUploadSuccess === 0) {
                this.$toast('当前文件即将上传成功，请稍后处理');
            }else{
                this.ossUploadProgressPopupCancelShow = false // 关闭弹窗 （必须先关闭）
                // 如果点击取消的时候，流程没有进入存证 代码继续往下走，如果已经进入了存证接口，那么执行下面的函数，重新执行固化、、存证函数，继续存证
                if (this.isOriginal && currentObj.ossSliceUploadSuccess !== 0) {
                    await this.existingEvidence({ existingEvidenceType: 2 })
                }
            }
        },
    },
};
</script>
<style src="../../assets/css/applyTime.less" scoped lang="less"></style>
